import React from "react";
import Slider from "react-slick";
import { blogs } from "./../blogs"; // Import the blogs array from blogs.js
import { Link } from "react-router-dom";

const BlogSection = () => {
  // Slider settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="space space-extra-bottom blog-wrapper">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xl-7 col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
            <div className="title-area">
              <span className="sec-subtitle">Insights & Tips</span>
              <h2 className="sec-title h1">Latest Blog Posts</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <Slider {...settings}>
            {blogs.map((blog, index) => (
              <div className="col-xl-4 p-2" key={index}>
                <div
                  className="vs-blog blog-style5"
                  style={{
                    backgroundImage: `url(${blog.mainImg})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="blog-content">
                    <div className="blog-body">
                      <Link
                        className="blog-date"
                        to={`/blogs/blog-details/${blog.id}/`}
                      >
                        {blog.date}
                      </Link>
                      <h2 className="blog-title h4">
                        <Link to={`/blogs/blog-details/${blog.id}/`}>
                          {blog.title.slice(0, 50)}
                        </Link>
                      </h2>
                      <div className="blog-bottom">
                        <Link
                          className="blog-link"
                          to={`/blogs/blog-details/${blog.id}/`}
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM11.05 5.95C11.05 7.35837 9.90837 8.5 8.5 8.5C7.09164 8.5 5.95 7.35837 5.95 5.95C5.95 4.54168 7.09164 3.4 8.5 3.4C9.90837 3.4 11.05 4.54168 11.05 5.95ZM8.5 15.725C10.0164 15.725 11.4237 15.2578 12.5859 14.4595C13.0992 14.1069 13.3185 13.4353 13.0201 12.8887C12.4015 11.7558 11.1267 11.05 8.49992 11.05C5.87324 11.05 4.59847 11.7557 3.97982 12.8887C3.68139 13.4353 3.90073 14.1069 4.41402 14.4594C5.57615 15.2578 6.98352 15.725 8.5 15.725Z"
                              fill="#37D4D9"
                            />
                          </svg>
                          by {blog.authorName}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
